import React from 'react';
import { AlertTriangle, Crosshair, Loader2 } from 'lucide-react';

// Avisos del chequeo de encuadre (ver frameAlign.js).
const FramingNotice = ({ framing }) => {
  if (!framing) return null;
  if (framing.notice) {
    return (
      <p className="mt-2 flex items-start gap-1.5 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-2.5 py-1.5">
        <Crosshair className="w-3.5 h-3.5 mt-0.5 shrink-0" />
        <span>
          {framing.notice.text}{' '}
          {framing.hasOriginal && (
            <button type="button" onClick={framing.showOriginal} className="font-medium text-blue-700 hover:underline">
              Ver antes del cambio
            </button>
          )}
        </span>
      </p>
    );
  }
  if (framing.warning) {
    return (
      <p className="mt-2 flex items-start gap-1.5 text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-2.5 py-1.5">
        <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" />
        <span>{framing.warning}</span>
      </p>
    );
  }
  if (framing.alignment?.status === 'aligned') {
    return (
      <p className="mt-2 text-xs text-gray-500">
        La cámara se corrió un poco entre las dos fotos: alineamos la de antes automáticamente.
      </p>
    );
  }
  return null;
};

// Mientras se chequea / busca. Con el precalculado casi no se ve; la búsqueda en el navegador muestra
// cuánto falta (progress 0..1).
export const FramingLoading = ({ searching, progress }) => {
  const pct = searching && progress != null ? Math.round(Math.min(1, Math.max(0, progress)) * 100) : null;
  return (
    <div className="w-full aspect-video bg-gray-100 rounded-lg relative">
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-sm text-gray-500 px-4 text-center">
        <Loader2 className="w-8 h-8 animate-spin text-gray-400" />
        {searching ? (
          <>
            <span className="text-gray-700 font-medium">La cámara se movió en algún momento.</span>
            <span>Buscando desde qué día se ve igual que hoy…</span>
            {pct != null && (
              <div className="w-full max-w-xs mt-1" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct}>
                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div className="h-full bg-blue-500 rounded-full transition-all duration-300" style={{ width: `${Math.max(4, pct)}%` }} />
                </div>
                <div className="mt-1 text-xs text-gray-400">{pct}% · la próxima vez es al instante</div>
              </div>
            )}
          </>
        ) : 'Comprobando que las dos fotos se vean desde el mismo lugar…'}
      </div>
    </div>
  );
};

export default FramingNotice;
